import React, { useCallback } from 'react';

import {
  useDelete,
  useNotify,
  useRecordContext,
  useRefresh,
} from 'react-admin';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { RemoveCircle } from '@mui/icons-material';

import useDialogStatus from '../../../hooks/useDialogStatus';

const SnapshotDeleteButton = ({ snapshotId }: { snapshotId: string }) => {
  const { open, openDialog, closeDialog } = useDialogStatus();
  const [deleteOne] = useDelete();
  const record = useRecordContext();
  const refresh = useRefresh();

  const notify = useNotify();
  const handleClick = useCallback(() => {
    if (!record) return;
    deleteOne(
      `cases/${record.id}/transaction-snapshot`,
      {
        id: snapshotId,
      },
      {
        onSuccess: () => {
          notify('Snapshot deleted', { type: 'info' });
          refresh();
        },
        onError: () => {
          notify('Could not delete snapshot', { type: 'error' });
        },
      },
    );
    closeDialog();
  }, [closeDialog, deleteOne, notify, record, refresh, snapshotId]);

  if (!record) return null;
  return (
    <>
      <Dialog open={open} onClose={closeDialog}>
        <DialogTitle>Delete Snapshot</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to remove the snapshot from the case? This action is irreversible.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>Cancel</Button>
          <Button onClick={handleClick} variant="contained">Confirm</Button>
        </DialogActions>
      </Dialog>
      <Button color="error" startIcon={<RemoveCircle />} onClick={openDialog}>
        Delete
      </Button>
    </>
  );
};

export default SnapshotDeleteButton;
